module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAAoCAYAAAAVBmHYAAAA/UlEQVRIie2XvUoDQRhFzyYR3JAUlvoGgliZLk9k57uYvIK+gw8h2Fha2hnighYaTorMwkL2Z8ApLObCsN/snTnc2W3mQy3Ve3VrGm0DryzUFXBLu16Anw4P4AS47vBWhfoBnLWY38C0B1yrAmYt7zeFas/GV+Crx58Cl11mE14Bv0MxIzQB5gA0fsRSJcFY1sBRgqSdyvAMz/AMz/AMz/AMT6hJo74BThMwr+pi6K74J/2bb/4E3IVnnCK7hWd1HC6a4zAfVGzyN2AX6l2YJ0v+qS5C8oVaxWzqa1uOcgDvwDlQRKzfjIDHqCMegBeRYIAHPLSKa9O2imu13AN7jdgjoQ6IagAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/mobile_icon.png
// module id = 699
// module chunks = 0